import React from 'react';
import { includes } from 'lodash';
import cx from 'classnames';
import { REQUIRED_OPTION_WIDGET_TITLE_WIDGET_TYPE_LIST } from '../../../../../constants/service/app/widgetConstants';
import './WidgetPreviewTitle.scss';

const WidgetPreviewTitle = (props) => {
  const { widgetType, mainTitle, isUsedSubTitle, subTitle } = props;
  return (
    <div className={cx('widget-preview-title', { 'is-empty': !mainTitle && !subTitle })}>
      {mainTitle ? (
        <div className="widget-main-title">{mainTitle}</div>
      ) : includes(REQUIRED_OPTION_WIDGET_TITLE_WIDGET_TYPE_LIST, widgetType) ? (
        <span className="require-info">위젯 타이틀을 설정해주세요.</span>
      ) : null}

      {isUsedSubTitle ? (
        <div className="widget-sub-title">
          {subTitle ? subTitle : <span className="require-info">위젯 서브 타이틀을 설정해주세요.</span>}
        </div>
      ) : null}
    </div>
  );
};

export default WidgetPreviewTitle;
